import { render, staticRenderFns } from "./QualityTesting.vue?vue&type=template&id=4c2c4719&scoped=true"
import script from "./QualityTesting.vue?vue&type=script&lang=js"
export * from "./QualityTesting.vue?vue&type=script&lang=js"
import style0 from "./QualityTesting.vue?vue&type=style&index=0&id=4c2c4719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c4719",
  null
  
)

export default component.exports